var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoneSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.79 0 0 7.79 310.3 242.4)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.57 0 0 2.57 16.95 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(13,177,75)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-120.59, -10.82)",
    d: "M 115.986 0.00196384 C 115.522 -0.0304218 115.123 0.342013 115.123 0.803509 V 5.14319 C 115.123 5.53991 115.408 5.88806 115.798 5.93663 C 118.223 6.26049 120.095 8.32508 120.095 10.8188 C 120.095 13.3125 118.223 15.3771 115.798 15.7009 C 115.408 15.7576 115.123 16.1057 115.123 16.4944 V 20.834 C 115.123 21.3036 115.522 21.6761 115.986 21.6356 C 121.624 21.1984 126.067 16.5186 126.067 10.8188 C 126.059 5.1189 121.624 0.43917 115.986 0.00196384 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.57 0 0 2.57 -16.55 0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(13,177,75)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-107.56, -10.83)",
    d: "M 111.803 21.4089 L 102.471 12.1223 C 101.755 11.4098 101.755 10.252 102.471 9.53954 L 111.803 0.252953 C 112.316 -0.257121 113.187 0.107217 113.187 0.819701 V 20.834 C 113.187 21.5546 112.316 21.9109 111.803 21.4089 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoneSmall);
export default __webpack_public_path__ + "static/media/stone-small.dab60d1be291b11163a92b7df4ee1b9f.svg";
export { ForwardRef as ReactComponent };